import { AdacHeadline } from '@adac-de/component-library';
import React from 'react';
import { Richtext } from '@components/richtext/richtext';

type OfferFormProps = {
  partners: PvWizardSectionOffer['partners'];
};

export const PartnerBoxIntro: React.FC<OfferFormProps> = ({ partners }) => (
  <>
    {partners.subheadline && (
      <AdacHeadline tagName="h3" styleAs="h4" className="margin-bottom--xs" id="partner-headline">
        {partners.subheadline}
      </AdacHeadline>
    )}
    <Richtext document={partners.body} textType="medium" />
  </>
);
